import { FBFirestoreRef } from '@/helpers/firebase/services';


// users collection
export function getUser(userId) {
  return FBFirestoreRef
    .collection('users')
    .doc(userId);
}

// Global buyer
export function getBuyerPublicProfile(buyerId) {
  return FBFirestoreRef
    .collection('buyers')
    .doc(buyerId)
    .collection('publicProfile')
    .doc('profile');
}
export function getBuyers() {
  return FBFirestoreRef.collection('buyers');
}
export function getBuyer(buyerId) {
  return getBuyers().doc(buyerId);
}

// sellers collection
export function getSellers() {
  return FBFirestoreRef.collection('sellers');
}
export function getSeller(sellerId) {
  return getSellers().doc(sellerId);
}
export function getSellerBuyers(sellerId) {
  return getSeller(sellerId).collection('buyers');
}
export function getSellerBuyer(sellerId, buyerId) {
  return getSellerBuyers(sellerId).doc(buyerId);
}
export function getSellerBuyerGroups(sellerId) {
  return getSeller(sellerId).collection('buyerGroups');
}
export function getSellerActiveBuyerGroups(sellerId) {
  return getSellerBuyerGroups(sellerId).where('status', '==', 0);
}
export function getSellerBuyerGroup(sellerId, buyerGroupId) {
  return getSellerBuyerGroups(sellerId).doc(buyerGroupId);
}
export function getSellerContactLists(sellerId) {
  return getSeller(sellerId).collection('contactLists');
}
export function getSellerContactList(sellerId, contactListId) {
  return getSellerContactLists(sellerId).doc(contactListId);
}
export function getSellerContactListContacts(sellerId, contactListId) {
  return getSellerContactList(sellerId, contactListId).collection('contacts');
}
export function getSellerContactListContact(sellerId, contactListId, contactId) {
  return getSellerContactListContacts(sellerId, contactListId).doc(contactId);
}
export function getSellerPublicProfile(sellerId) {
  return getSeller(sellerId)
    .collection('publicProfile')
    .doc('profile');
}
export function getSellerBusinessLocation(sellerId) {
  return getSeller(sellerId)
    .collection('businessLocation')
    .doc('address');
}
export function getBuyerBusinessLocation(buyerId) {
  return getBuyer(buyerId)
    .collection('businessLocation')
    .doc('address');
}
export function getSellerReports(sellerId) {
  return getSeller(sellerId).collection('reports');
}
export function getSellerReport(sellerId, reportId) {
  return getSellerReports(sellerId).doc(reportId);
}
export function getSellerSMSCampaigns(sellerId) {
  return getSeller(sellerId).collection('smsCampaigns');
}
export function getSellerSMSCampaign(sellerId, SMSCampaignId) {
  return getSellerSMSCampaigns(sellerId).doc(SMSCampaignId);
}
export function getSellerTeamMembers(sellerId) {
  return getSeller(sellerId).collection('teamMembers');
}


// buyerGroups collection
export function getBuyerGroupPublicProfile(buyerGroupId) {
  return FBFirestoreRef
    .collection('buyerGroups')
    .doc(buyerGroupId)
    .collection('publicProfile')
    .doc('profile');
}


// vehicles collection
export function getVehicles() {
  return FBFirestoreRef.collection('vehicles');
}
export function getUserVehicles(userId) {
  return getVehicles().where('teamMembers', 'array-contains', userId);
}
export function getVehicle(vehicleId) {
  return getVehicles().doc(vehicleId);
}
export function getVehicleBids(vehicleId) {
  return getVehicle(vehicleId).collection('bids');
}
export function getVehicleBid(vehicleId, bidId) {
  return getVehicleBids(vehicleId).doc(bidId);
}
export function getVehicleRounds(vehicleId) {
  return getVehicle(vehicleId).collection('rounds');
}
export function getVehicleHits(vehicleId) {
  return getVehicle(vehicleId).collection('hits');
}
export function getVehicleImages(vehicleId) {
  return getVehicle(vehicleId).collection('images');
}
export function getVehicleImage(vehicleId, imageId) {
  return getVehicleImages(vehicleId).doc(imageId);
}

// vehicleFilters collection
export function getVehicleFilters() {
  return FBFirestoreRef.collection('vehicleFilters');
}
export function getVehicleFiltersOfType(vehicleType) {
  return getVehicleFilters().where('forVehicleType', 'in', [vehicleType, 'common']);
}
